/* OURLUX ™ — défilement des CTA vers la fiche produit / le sélecteur de quantité */
(function () {
  function headerOffset() {
    var h = document.querySelector('sticky-header, .section-header, header.header');
    var v = h ? h.getBoundingClientRect().height : 0;
    if (!v || v > 200) v = 0;
    return v + 12;
  }

  function findTarget() {
    return (
      document.querySelector('.quantity-breaks-container') ||
      document.querySelector('.quantity-breaks') ||
      document.querySelector('product-info, .product__info-wrapper, .product__info-container') ||
      document.querySelector('[id^="shopify-section"][id$="__main"]')
    );
  }

  function scrollToOffer(e) {
    var el = findTarget();
    if (!el) return;
    if (e) e.preventDefault();
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    if (top < 0) top = 0;
    var start = window.pageYOffset;
    try {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, top);
    }
    // repli si le défilement animé est indisponible (navigateur, « reduced motion », iframe…)
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) < 4 && Math.abs(start - top) > 8) {
        window.scrollTo(0, top);
      }
    }, 320);
    var radio = document.querySelector('.quantity-breaks-container input[type="radio"]:checked');
    if (radio && radio.focus) {
      setTimeout(function () { try { radio.focus({ preventScroll: true }); } catch (err) {} }, 600);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ourx-scroll]') : null;
    if (btn) scrollToOffer(e);
  });

  window.ourxScrollToOffer = scrollToOffer;
})();
